// src/App.jsx
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';
import './App.css';

function App() {
    const [message, setMessage] = useState("");
    const [selectedSoftware, setSelectedSoftware] = useState(null); // Estado para el modal

    const handleBuyClick = (softwareName) => {
        setMessage(`Thank you for showing interest in ${softwareName}!`);
        setTimeout(() => setMessage(""), 3000);
    };

    const handleCardClick = (software) => {
        setSelectedSoftware(software); // Establecer el software seleccionado
        console.log(software)
    };

    const handleCloseModal = () => {
        setSelectedSoftware(null); // Cerrar el modal
    };


    return (
        <div className="App">
            <Helmet>
                <title>4StoryPro - Gaming Tools & Bots</title>
                <meta name="description" content="Enhance your 4Story gameplay with our premium tools and bots. Optimize your gaming experience with 4StoryPro." />
            </Helmet>
            
            <div className="video-background">
                <video autoPlay loop muted>
                    <source src="/background.mp4" type="video/mp4"/>
                    Your browser does not support the video tag.
                </video>
            </div>
            <header className="header">
                <div className="logo">4StoryPro</div>
                {/*<nav>*/}
                {/*    <ul className="nav-links">*/}
                {/*        <motion.li*/}
                {/*            whileHover={{scale: 1.2, color: '#e94560'}}*/}
                {/*            transition={{type: 'spring', stiffness: 300}}*/}
                {/*        >*/}
                {/*            <a href="#features">Features</a>*/}
                {/*        </motion.li>*/}
                {/*        <motion.li*/}
                {/*            whileHover={{scale: 1.2, color: '#e94560'}}*/}
                {/*            transition={{type: 'spring', stiffness: 300}}*/}
                {/*        >*/}
                {/*            <a href="#software">Software</a>*/}
                {/*        </motion.li>*/}
                {/*        <motion.li*/}
                {/*            whileHover={{scale: 1.2, color: '#e94560'}}*/}
                {/*            transition={{type: 'spring', stiffness: 300}}*/}
                {/*        >*/}
                {/*            <a href="#contact">Contact</a>*/}
                {/*        </motion.li>*/}
                {/*    </ul>*/}
                {/*</nav>*/}
                {/*<motion.button*/}
                {/*    className="buy-now"*/}
                {/*    whileHover={{scale: 1.1, backgroundColor: '#e94560'}}*/}
                {/*>*/}
                {/*    Buy Now*/}
                {/*</motion.button>*/}
            </header>

            <motion.section
                className="hero"
                initial={{opacity: 0, scale: 0.8}}
                animate={{opacity: 1, scale: 1}}
                transition={{duration: 1}}
            >
                <h1>Unlock the Ultimate Gaming Experience with 4StoryPro</h1>
                <p>Enhance your gameplay with cutting-edge tools designed specifically for 4Story. Optimize, dominate,
                    and enjoy!</p>
                <motion.button
                    className="cta-button"
                    whileHover={{scale: 1.1, backgroundColor: '#e94560'}}
                    whileTap={{scale: 0.9}}
                >
                    Explore Now
                </motion.button>
            </motion.section>

            <section id="features" className="features">
                <h2>Why Choose 4StoryPro?</h2>
                <div className="feature-list">
                    {[
                        {
                            title: 'Game Optimization',
                            description:
                                'Enhance game performance by optimizing graphics and reducing lags, ensuring a seamless experience even in competitive gameplay.',
                        },
                        {
                            title: 'Automation Tools',
                            description:
                                'Automate tedious tasks like farming resources or completing quests, allowing you to focus on strategic gameplay.',
                        },
                        {
                            title: 'Custom Mods',
                            description:
                                'Unlock new experiences with customizable mods tailored to enhance your gaming style, from visuals to mechanics.',
                        },
                    ].map((feature, index) => (
                        <motion.div
                            className="feature-item"
                            whileHover={{
                                scale: 1.1,
                                rotate: 5,
                                boxShadow: '0 0 20px var(--secondary-color)',
                            }}
                            transition={{duration: 0.3}}
                            key={index}
                        >
                            <h3>{feature.title}</h3>
                            <p>{feature.description}</p>
                        </motion.div>
                    ))}
                </div>
            </section>


            <section id="software" className="software">
                <h2>Our Software</h2>
                <div className="software-grid">
                    {[{
                        name: '4Story CaptchaSolver',
                        price: '$19.99',
                        image: "/logo.png",
                        disabled: false,
                        description: 'A tool to solve captchas automatically and save time while playing. The bot can solve sum and subtraction problems to avoid getting kicked by the server.'
                    }, {
                        name: '4Story Bot',
                        price: '$24.99',
                        image: 'https://gf1.geo.gfsrv.net/cdn35/36145edb60487fe9d8bbd20498ef61',
                        disabled: true,
                        description: 'Pre-configure key sequences and their timing. It also allows area skills and can sell items automatically when the bags are full if you have Salesman.'
                    }, {
                        name: '4Story Macro Recorder Bot',
                        price: '$24.99',
                        image: 'https://mmoculture.com/wp-content/uploads/2020/10/4Story-image.png',
                        disabled: true,
                        description: 'Record a farming sequence to automate your activities. The bot will repeat the tasks and sell items when the bags are full, with Salesman support.'
                    }].map((software, index) => (
                        <motion.div
                            className="software-card"
                            key={index}
                            whileHover={{
                                scale: 1.1,
                                rotate: -2,
                                boxShadow: '0 0 15px var(--secondary-color)',
                            }}
                            transition={{duration: 0.3}}
                            onClick={() => handleCardClick(software)} // Mostrar modal al hacer clic
                        >
                            <img src={software.image} alt={software.name} className="software-image"/>
                            <h3>{software.name}</h3>
                            <p>{software.price}</p>
                            <motion.button
                                className="buy-button"
                                whileHover={{scale: 1.1}}
                                whileTap={{scale: 0.9}}
                                onClick={() => software.disabled ? null : handleBuyClick(software.name)}
                                disabled={software.disabled}
                            >
                                {software.disabled ? 'Coming Soon' : 'Buy Now'}
                            </motion.button>
                        </motion.div>
                    ))}
                </div>
                {message && <p className="message">{message}</p>}
            </section>

            {/* Modal Section */}
            {selectedSoftware && (
                <div className="modal-overlay" onClick={handleCloseModal}>
                    <div className="modal" onClick={(e) => e.stopPropagation()}>
                        <h2>{selectedSoftware.name}</h2>
                        <img src={selectedSoftware.image} alt={selectedSoftware.name} className="modal-image"/>
                        <p>{selectedSoftware.description}</p>
                        <p>{selectedSoftware.price}</p>
                        <motion.button
                            className="buy-button"
                            whileHover={{scale: 1.1}}
                            whileTap={{scale: 0.9}}
                            onClick={() => handleBuyClick(selectedSoftware.name)}
                        >
                            {selectedSoftware.disabled ? 'Coming Soon' : 'Buy Now'}
                        </motion.button>
                        {/*<button className="close-modal" onClick={handleCloseModal}>Close</button>*/}
                    </div>
                </div>
            )}
            <footer id="contact" className="footer">
                <motion.p
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    transition={{delay: 0.5, duration: 1}}
                >
                    © 2024 4StoryPro. All rights reserved.
                </motion.p>
                <p>Follow us on <a href="#">Discord</a></p>
            </footer>
        </div>
    );
}

export default App;
